import Axios from "@/utils/Axios";
import config from "@/config";

const getSharerUid = () => {
  const sharerUid = localStorage.getItem("sharerUid");
  return sharerUid ? `?inviter_id=${sharerUid}` : "";
};

// 退出登录
export const logout = () => {
  return Axios.post("/user/api/v1/logout", withSourceName({}), {}, config.adminUrl);
};

// 通过验证码登录
export interface LoginByVCodeRequestData {
  code: string;
  mobileNumber: string;
  email: string;
  channel_code?: string;
}
export function loginByPhoneVerificationCode(data: LoginByVCodeRequestData) {
  return Axios.post(
    `/user/api/v1/sms/verification/login${getSharerUid()}`,
    withChannel(withSourceName(data)),
    {},
    config.adminUrl,
  );
}

export function loginByEmailVerificationCode(data: LoginByVCodeRequestData) {
  return Axios.post(
    `/user/api/v1/email/verification/login${getSharerUid()}`,
    withChannel(withSourceName(data)),
    {},
    config.adminUrl,
  );
}

// 微信扫码登录
export interface LoginByWeChatQrCodeRequestData {
  key: string;
}
export function loginByWeChatQrCode(data: LoginByWeChatQrCodeRequestData) {
  return Axios.post(
    `/user/api/v1/wechat/official-account/qrcode/login${getSharerUid()}`,
    withSourceName(data),
    {},
    config.adminUrl,
  );
}

export function getWeChatQrCodeScanStatus(data: { key: string }) {
  return Axios.post(
    "/user/api/v1/wechat/official-account/qrcode/status",
    withSourceName({ block: 0, ...data }),
    {},
    config.adminUrl,
  );
}

// 获取微信扫码二维码
export function getWeChatQrCode() {
  return Axios.post(
    "/user/api/v1/wechat/official-account/qrcode",
    withSourceName({}),
    {},
    config.adminUrl,
  );
}

/* 密码登录 */
export interface LoginByPasswordRequestData {
  // username email 只能存在一个，不能同时为空
  username?: string; // 一般表示手机号，字段有歧义
  password: string;
  email?: string;
}
export function loginByPassword(data: LoginByPasswordRequestData) {
  return Axios.post(
    `/user/api/v1/login${getSharerUid()}`,
    withSourceName(data),
    {},
    config.adminUrl,
  );
}

/* 注册 */
export function register(data: { email: string; password: string; confirmPassword: string }) {
  return Axios.post("/auth/register", withChannel(withSourceName(data)), {}, config.baseURL);
}

// 微信扫码后绑定手机号
export interface BindPhoneWithWeChatRequestData {
  code: string;
  key: string;
  mobileNumber: string;
  channel_code?: string;
}
export function bindPhoneWithWeChat(data: BindPhoneWithWeChatRequestData) {
  return Axios.post(
    `/user/api/v1/wechat/official-account/qrcode/login/phone${getSharerUid()}`,
    withChannel(withSourceName(data)),
    {},
    config.adminUrl,
  );
}

// 会员状态-Get
export const getMemberStatus = async () => {
  return Axios.get("/v1/member/status", {}, {}, config.baseURL);
};

// 获取用户数据
export function getUserBaseInfo() {
  return Axios.get("/user/api/v1/user/profile/base", {}, {}, config.adminUrl);
}

export function getUserInfoWithPermission() {
  return Axios.get("api/v1/getinfo", {}, {}, config.adminUrl);
}

export enum LoginEvent {
  // 登录
  LOGIN = "login",
  // 退出
  LOGOUT = "logout",
}

export interface GetPhoneVCodeRequestData {
  mobileNumber: string;
}
export function getPhoneVCode(data: GetPhoneVCodeRequestData) {
  return Axios.post("/user/api/v1/sms/verification", withSourceName(data), {}, config.adminUrl);
}

export interface GetEmailVCodeRequestData {
  email: string;
  // 决定发送验证码文案主题
  subject: number;
}
export function getEmailVCode(data: GetEmailVCodeRequestData) {
  return Axios.post("/user/api/v1/email/verification", withSourceName(data), {}, config.adminUrl);
}

// 忘记密码
export interface ForgotPasswordRequestData {
  code: string;
  password: string;
  // 手机号、邮箱二选一，一个有值时另一个置空
  mobileNumber: string;
  email: string;
}

// 忘记密码 手机验证码
export function forgotPassword(data: ForgotPasswordRequestData) {
  return Axios.post(
    "/user/api/v1/sms/verification/forget",
    withSourceName(data),
    {},
    config.adminUrl,
  );
}

/* ----------------------------------- 注册 ----------------------------------- */
// 邮箱注册
export interface EmailRegisterRequestData {
  email: string;
  code: string | number;
  name: string;
  password: string;
}
export function emailRegister(data: EmailRegisterRequestData) {
  return Axios.post(
    "/user/api/v1/email/register",
    withChannel(withSourceName(data)),
    {},
    config.adminUrl,
  );
}

// 手机验证码注册
export interface SmsRegisterRequestData {
  mobileNumber: string | number;
  code: string | number;
  name: string;
  password: string;
  channel_code?: string;
}
export function smsRegister(data: SmsRegisterRequestData) {
  return Axios.post(
    "/user/api/v1/sms/verification/register",
    withChannel(withSourceName(data)),
    {},
    config.adminUrl,
  );
}

function withSourceName<T>(data: T) {
  return {
    ...data,
    source_name: "creator",
  };
}

function withChannel<T>(data: T) {
  const channel = sessionStorage.getItem("channelTrace");
  if (!channel) return data;
  return {
    ...data,
    channel_code: channel,
  };
}
